<template>
  <section class="projects" aria-label="Projekter">
    <h2 class="heading">Mine projekter</h2>
    <div class="grid">
      <ProjectCard v-for="(p, i) in projects" :key="i" :project="p" />
    </div>
  </section>
</template>

<script>
import projects from '@/data/projects.json'
import ProjectCard from '@/components/ProjectCard.vue'

export default {
  name: 'ProjectGrid',
  components: { ProjectCard },
  data() {
    return { projects }
  }
}
</script>

<style scoped>
.projects { padding: 28px 18px; }
.heading { margin-bottom: 18px; color: var(--text, #111); font-size:1.25rem; }

.grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, 1fr);
}

@media (max-width: 980px) { .grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 640px) { .grid { grid-template-columns: 1fr; } }
</style>